/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   tabs-automatic.js
 *
 *   Desc:   Tablist widget that implements ARIA Authoring Practices
 *
 *  This software or document includes material copied from Atomatic Tabs - https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/tabs/examples/js/tabs-automatic.js.
 *  Copyright © 2023 World Wide Web Consortium. https://www.w3.org/copyright/software-license-2023/
 */
(function () {
    'use strict';

    class TabsAutomatic {
        constructor(groupNode) {
            this.tablistNode = groupNode;

            this.tabs = [];

            this.firstTab = null;
            this.lastTab = null;

            this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
            this.tabpanels = [];

            for (var i = 0; i < this.tabs.length; i += 1) {
                var tab = this.tabs[i];
                var tabpanel = document.getElementById( tab.getAttribute('aria-controls') );

				tab.tabIndex = -1;
                tab.setAttribute('aria-selected', 'false');
                this.tabpanels.push(tabpanel);

				tab.addEventListener('keydown', this.onKeydown.bind(this));
                tab.addEventListener('click', this.onClick.bind(this));

                if (!this.firstTab) {
                    this.firstTab = tab.getAttribute('aria-controls');
                }
                this.lastTab = tab.getAttribute('aria-controls');
            }

            this.setSelectedTab(this.firstTab, false);
        }

        setSelectedTab(currentTab, setFocus) {

			if (typeof setFocus !== 'boolean') {
                setFocus = true;
            }
            for (var i = 0; i < this.tabs.length; i += 1) {
                var tab = this.tabs[i];
                if ( currentTab === tab.getAttribute('aria-controls') ) {
					tab.setAttribute('aria-selected', 'true');
                    tab.removeAttribute('tabindex');
                    this.tabpanels[i].classList.remove('is-hidden');

                    if (setFocus) {
                        tab.focus();
                    }
                } else {
                    tab.setAttribute('aria-selected', 'false');
                    tab.tabIndex = -1;
					if ( this.tabpanels[i] ) {
						this.tabpanels[i].classList.add('is-hidden');
					}
                }

            }

			$('.card-carousel')?.slick( 'setPosition' );

        }

        setSelectedToPreviousTab(currentTab) {
            var index;

            if (currentTab === this.firstTab) {
                this.setSelectedTab(this.lastTab);
            } else {
                index = this.tabs.indexOf(currentTab);
                this.setSelectedTab(this.tabs[index - 1].getAttribute('aria-controls'));
            }
        }

        setSelectedToNextTab(currentTab) {
            var index;

            if (currentTab === this.lastTab) {
                this.setSelectedTab(this.firstTab);
            } else {
                index = this.tabs.indexOf(currentTab);
                this.setSelectedTab(this.tabs[index + 1].getAttribute('aria-controls'));
            }
        }

        /* EVENT HANDLERS */

        onKeydown(event) {
            var tgt = event.currentTarget,
                flag = false;

            switch (event.key) {
                case 'ArrowLeft':
                    this.setSelectedToPreviousTab(tgt);
                    flag = true;
                    break;

                case 'ArrowRight':
                    this.setSelectedToNextTab(tgt);
                    flag = true;
                    break;

                case 'Home':
                    this.setSelectedTab(this.firstTab);
                    flag = true;
                    break;

                case 'End':
                    this.setSelectedTab(this.lastTab);
                    flag = true;
                    break;

                default:
                    break;
            }

            if (flag) {
                event.stopPropagation();
                event.preventDefault();
            }
        }

        onClick(event) {
            this.setSelectedTab(event.currentTarget.getAttribute('aria-controls'));
        }
    }

    // Initialize tablist

    window.addEventListener('load', function () {
        var tablists = document.querySelectorAll('[role=tablist].automatic');
        for (var i = 0; i < tablists.length; i++) {
            new TabsAutomatic(tablists[i]);
        }
    });

})();
